import { render, staticRenderFns } from "./ImagesTypeProductItemTemplate.vue?vue&type=template&id=cd646bfc&scoped=true&"
import script from "./ImagesTypeProductItemTemplate.vue?vue&type=script&lang=js&"
export * from "./ImagesTypeProductItemTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImagesTypeProductItemTemplate.vue?vue&type=style&index=0&id=cd646bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd646bfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
